import axios from 'axios';

export default {
    checkAvailability() {
        const options = {
            url: window.apiUrl + '/software-availability',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getSoftware() {
        const options = {
            url: window.apiUrl + '/software',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getKeys(context) {
        const options = {
            url: window.apiUrl + '/software-keys',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    createNeeds(softwareIds, softwareNames) {
        const options = {
            url: window.apiUrl + '/software-need',
            method: 'POST',
            data: { softwareIds: softwareIds, softwareNames: softwareNames },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
};



// WEBPACK FOOTER //
// ./src/services/software/index.js